import $ from 'jquery';
/**
 * @description Activate product form quantity controls
 */ export const init = async function() {
    $('.js-product-qty-controls').each(function(_, element) {
        const controls = $(element);
        const field = controls.find('input[name="quantity"]');
        const indicator = controls.find('.js-qty-indicator');
        const rawInitialQty = field.val();
        const initialQty = typeof rawInitialQty === 'string' ? parseInt(rawInitialQty, 10) : typeof rawInitialQty === 'number' ? rawInitialQty : null;
        if (initialQty == null) {
            throw new Error('Quantity is not a number');
        }
        indicator.text(initialQty);
        controls.find('button').on('click', function(evt) {
            const action = $(evt.delegateTarget).attr('data-action');
            const rawCurrentQty = field.val();
            const currentQty = typeof rawCurrentQty === 'string' ? parseInt(rawCurrentQty, 10) : typeof rawCurrentQty === 'number' ? rawCurrentQty : null;
            if (currentQty == null) {
                throw new Error('Quantity is not a number');
            }
            const updatedQty = action === 'plus' ? currentQty + 1 : action === 'minus' && currentQty > 1 ? currentQty - 1 : currentQty;
            field.val(updatedQty);
            indicator.text(updatedQty);
        });
    });
};
